export default __webpack_public_path__ + "static/media/ar.e196dc19.svg";